import { render } from "./InformationDialog.vue?vue&type=template&id=0c2434d6&scoped=true"
import script from "./InformationDialog.vue?vue&type=script&lang=js"
export * from "./InformationDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=0c2434d6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2434d6"]])

export default __exports__